// extracted by mini-css-extract-plugin
export var carrierNotice = "_m5-5";
export var carrierNoticePlaceholder = "_m5-6";
export var deliveryRow = "_m5-c";
export var fixedHeight = "_m5-4";
export var freightLogo = "_m5-b";
export var fullWidth = "_m5-3";
export var priceColumn = "_m5-7";
export var radioSelected = "_m5-9";
export var radioUnselected = "_m5-8";
export var selectedOption = "_m5-2";
export var selectedOptionContainer = "_m5-1";
export var selection = "_m5-0";
export var tallSkeletonText = "_m5-a";